import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import formimg from "../Forms/Performance-Appraisal-Templates-1-1013x439 1.svg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import SelectForm from "./SelectForm";
import { baseURL } from "../../config";

function AddCompForm() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);

  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = async () => {
    try {
      // Perform form submission with the stored form data
      console.log("Submitting form:", formData);

      // Here you can perform an API call or save the form data using your preferred method
      // For example, you can use fetch to send the form data to a server
      const response = await fetch(`${baseURL}/api/subgoal/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        // Reset form data and close modal after successful submission
        setFormData(null);
        setShowModal(false);

        // Redirect to the desired page
        window.location.href = "/subgoallist"; // Update "/goals" with the desired URL
      } else {
        // Handle the case where the form submission fails
        console.error("Form submission failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          Competency: "",
          definition: "",
        }}
        validationSchema={Yup.object({
          Competency: Yup.string().required("Competency name is required"),
          definition: Yup.string().required("Definition is required"),
        })}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <div className="container">
            <h4 className="text-start  pb-2">ADD NEW COMPETENCY</h4>
            <div className="col-lg-12  mt-1 m-5">
              <form noValidate onSubmit={handleSubmit}>
                <div className="row mt-3">
                  <div className="col-lg-5 ">
                    <label className="formlabel">
                      Enter Competency Name{" "}
                      <span className="text-danger">*</span>
                      <br />
                      [Please avoid special symbols]
                      <span>
                        <br />
                        Max 40 letters
                      </span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.title && errors.title ? "is-invalid" : ""
                      }`}
                      placeholder=""
                      name="competency"
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.title && errors.title ? (
                      <div className="text-danger">{errors.title}</div>
                    ) : null}
                  </div>

                  <div className="col-lg-5 ml-5">
                    <label>
                      Enter Competency Definition <br />
                      [Please avoid special symbols]
                      <span>
                        <br />
                        Max 250 letters
                      </span>
                    </label>
                    <textarea
                      className={`form-control ${
                        touched.description && errors.description
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder=""
                      name="description"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                    {touched.description && errors.description ? (
                      <div className="text-danger">{errors.description}</div>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-11 text-end mt-5 pb-3">
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <a className="text-decoration-none " href="/AddCompetencybut">
                    {" "}
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want create Competency</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleConfirmSubmit}>
            Yes
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddCompForm;
